import ConstantApi from '../../../../ConstantApi';
import axiosCall from '../../../axiosCall';
import { fetchDyeingDC } from '../../DyeingDC/dyeingDC/dyeingDC.actions';
import { fetchCompactingDC } from '../compactingDC/compactingDC.actions';
import {
    CREATE_COMPACTING_DC_DETAILS_FAILURE,
    CREATE_COMPACTING_DC_DETAILS_REQUEST,
    CREATE_COMPACTING_DC_DETAILS_SUCCESS,
    CREATE_USER_FORM_COMPACTING_DC_DETAILS,
    DELETE_COMPACTING_DC_DETAILS_FAILURE,
    DELETE_COMPACTING_DC_DETAILS_REQUEST,
    DELETE_COMPACTING_DC_DETAILS_SUCCESS,
    FETCH_SINGLE_COMPACTING_DC_DETAILS_FAILURE,
    FETCH_SINGLE_COMPACTING_DC_DETAILS_REQUEST,
    FETCH_SINGLE_COMPACTING_DC_DETAILS_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_FAILURE,
    FETCH_COMPACTING_DC_DETAILS_REQUEST,
    FETCH_COMPACTING_DC_DETAILS_SUCCESS,
    COMPACTING_DC_DETAILS_USERFORM_RESET,
    UPDATE_COMPACTING_DC_DETAILS_FAILURE,
    UPDATE_COMPACTING_DC_DETAILS_REQUEST,
    UPDATE_COMPACTING_DC_DETAILS_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_BY_ID_REQUEST,
    FETCH_COMPACTING_DC_DETAILS_BY_ID_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_BY_ID_FAILURE,
    FETCH_COMPACTING_DC_PREVIOUS_LIST_REQUEST,
    FETCH_COMPACTING_DC_PREVIOUS_LIST_SUCCESS,
    FETCH_COMPACTING_DC_PREVIOUS_LIST_FAILURE,
    FETCH_GRN_NO_BY_COMPACTING_PO_REQUEST,
    FETCH_GRN_NO_BY_COMPACTING_PO_SUCCESS,
    FETCH_GRN_NO_BY_COMPACTING_PO_FAILURE,
    FETCH_COMPACTING_DC_DETAILS_DC_NO_REQUEST,
    FETCH_COMPACTING_DC_DETAILS_DC_NO_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_DC_NO_FAILURE,
    FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_REQUEST,
    FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_FAILURE,
    COMPACTING_DC_PROGRAM_ID_REQUEST,
    COMPACTING_DC_PROGRAM_ID_FAILURE,
    COMPACTING_DC_PROGRAM_ID_SUCCESS,
    FETCH_COMPACTING_DC_DETAIL_REPROCESS_PREV_LIST_SUCCESS,
    FETCH_COMPACTING_DC_DETAIL_REPROCESS_PREV_LIST_REQUEST,
    FETCH_COMPACTING_DC_DETAIL_REPROCESS_PREV_LIST_FAILURE,
    FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST,
    FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE,
    FETCH_COMPACTING_DC_DETAILS_DIA_FROM_STYLE_REQUEST,
    FETCH_COMPACTING_DC_DETAILS_DIA_FROM_STYLE_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_DIA_FROM_STYLE_FAILURE,
    FETCH_COMPACTING_DC_FABRIC_STOCK_LIST_REQUEST,
    FETCH_COMPACTING_DC_FABRIC_STOCK_LIST_SUCCESS,
    FETCH_COMPACTING_DC_FABRIC_STOCK_LIST_FAILURE
} from './compactingDCDetails.actionsType';
import moment from 'moment';

// FETCH PROPERTY MASTER
export let fetchCompactingDCDetailsById = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDCDetailsGET_BY_ID}/${id}`,
        responseTypeRequest: FETCH_COMPACTING_DC_DETAILS_BY_ID_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_DETAILS_BY_ID_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_DETAILS_BY_ID_FAILURE
    };
    return axiosCall(config);
};

// FETCH PROPERTY MASTER
export let fetchCompactingDCDetails = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDCDetailsGET}`,
        responseTypeRequest: FETCH_COMPACTING_DC_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_DETAILS_FAILURE
    };
    return axiosCall(config);
};

export let fetchCompactingDCDetailsPreviousProgram = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDCDetailsProgramGET}`,
        responseTypeRequest: FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createCompactingDCDetailsUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_COMPACTING_DC_DETAILS, payload: { key, value } });
    };
};

export let fetchCompactingDCDetailsRatePrKgFrmStyle = (style, fabGrp, yarnCnt, fabric, dia, programId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.CompactingDCDetailsRatePrKgFrmStyleGET}?FldFKStyle=${style}&FabGrp=${fabGrp}&YarnCnt=${yarnCnt}&Fab=${fabric}&Dia=${dia}&FldFKProgram=${programId}`,
        responseTypeRequest: FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE
    };
    return axiosCall(config);
};

// CREATE PROPERTY MASTER
export let createCompactingDCDetails = (formData, modalClose, fldFKStyle, fldFkProgramId, salesId, IsCost, supplierId, reprocessID, headerUserForm, isDirectDetails, status,
    showPrevious


) => {
    console.log("formDatasss", formData);
    let today = new Date();

    let data = JSON.stringify({
        fldId: 0,
        fldFKDCNo: parseInt(formData.fldFKDCNo),
        fldReceivingRolls: 0,
        FldFKPreviousDCPO: parseInt(formData.FldFKPreviousDCPO),
        FldInwardDia: formData.FldInwardDia || '0',
        FldFKInwardDia: parseInt(formData.FldFKInwardDia),
        FldPreviousDCPO: formData.FldPreviousDCPO,
        // FldFKProgram: parseInt(formData.FldFKProgram),
        FldFKProgram: parseInt(formData.FldFKProgram || formData.fldFKProgram),
        FldProgram: formData.FldProgram,
        // fldFKFabricOrDyeingDc: parseInt(formData.fldFKFabricOrDyeingDc),
        // fldFKColour: parseInt(formData.fldFKColour),
        // fldDCNo: formData?.fldDCNo,
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldFKSaleOrder: parseInt(formData.fldFKSaleOrder),
        fldSalesOrderNo: formData.fldSalesOrderNo,
        fldFKYarnCounts: parseInt(formData.fldFKYarnCounts),
        fldYarnCounts: formData?.fldYarnCounts,
        fldStyleNumber: formData?.fldStyleNumber,
        fldStyleDescription: '',
        fldFKColour: parseInt(formData.fldFKColour),
        fldFKColourShade: parseInt(formData.fldFKColourShade),
        fldColourShade: formData?.fldColourShade,
        // fldFabricOrDyeingDC: formData?.fldFabricOrDyeingDC,
        fldColour: formData?.fldColour,
        fldFabricGroup: formData?.fldFabricGroup,
        fldFabric: formData?.fldFabric,
        TblFabricname: formData?.fldFabric,
        fldDia: formData?.fldDia,
        fldFKFabricMaster: parseInt(formData.fldFKFabricMaster),
        fldRate: Number(formData.fldRate),
        fldQuantity: formData.fldQuantity ? Number(formData.fldQuantity) : 0,
        fldGrossValue: formData.fldGrossValue ? Number(formData.fldGrossValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldTaxableValue: formData.fldTaxableValue ? Number(formData.fldTaxableValue) : 0,
        fldIGSTPercentage: formData.fldIGSTPercentage ? Number(formData.fldIGSTPercentage) : 0,
        fldIGSTValue: formData.fldIGSTValue ? Number(formData.fldIGSTValue) : 0,
        fldSGSTPercentage: formData.fldSGSTPercentage ? Number(formData.fldSGSTPercentage) : 0,
        fldSGSTValue: formData.fldSGSTValue ? Number(formData.fldSGSTValue) : 0,
        fldCGSTPercentage: formData.fldCGSTPercentage ? Number(formData.fldCGSTPercentage) : 0,
        fldCGSTValue: formData.fldCGSTValue ? Number(formData.fldCGSTValue) : 0,
        fldGSTValue: formData.fldGSTValue ? Number(formData.fldGSTValue) : 0,
        fldTotalValue: formData.fldTotalValue ? Number(formData.fldTotalValue) : 0,
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldProgram: formData.fldProgram,
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData?.fldEnteredSysId,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldFKStatus: 0,
        fldFKHSNCode: parseInt(formData.fldFKHSNCode) || 0,
        fldFKUOM: parseInt(formData.fldFKUOM),
        fldFKFabricGroup: parseInt(formData.fldFKFabricGroup),
        fldFKFabric: parseInt(formData.fldFKFabric),
        fldFKDia: parseInt(formData.fldFKDia),
        fldFKGSM: parseInt(formData.fldFKGSM),
        fldFKNoofRolls: parseInt(formData.fldFKNoofRolls),
        fldRequiredDia: formData?.fldRequiredDia ? formData?.fldRequiredDia : '0',
        fldRequiredGSM: formData?.fldRequiredGSM || '',
        fldFKWeightinKG: formData.fldFKWeightinKG ? Number(formData.fldFKWeightinKG) : 0,
        fldFKRatePerKG: 0,
        fldInwardQuantity: formData?.fldInwardQuantity ? Number(formData?.fldInwardQuantity) : 0,
        fldCancelQuantity: formData?.fldCancelQuantity ? Number(formData?.fldCancelQuantity) : 0,
        fldBalanceQuantity: formData?.fldBalanceQuantity ? Number(formData?.fldBalanceQuantity) : 0
    });
    // FldFKProgramUnit
    let config = {

        method: 'post',
        data,
        url: `${ConstantApi.compactingDCDetailsPOST}?FldInwardId=${(formData?.selectedRowKeys || formData?.inwardId).toString()}&ProgramId=${Number(formData.FldFKProgramUnit)}`,
        responseTypeRequest: CREATE_COMPACTING_DC_DETAILS_REQUEST,
        responseTypeSuccess: CREATE_COMPACTING_DC_DETAILS_SUCCESS,
        responseTypeFailure: CREATE_COMPACTING_DC_DETAILS_FAILURE,
        resetFormData: COMPACTING_DC_DETAILS_USERFORM_RESET,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        // getAllData: fetchCompactingDCDetailsById(parseInt(formData.fldFKDCNo))
        singlApiArray: [
            isDirectDetails ? fetchCompactingDC(
                moment(headerUserForm.startDate).format('YYYY-MM-DD'),
                moment(headerUserForm.endDate).format('YYYY-MM-DD'),
                headerUserForm.unitId || 1, status) : fetchCompactingDCReprocessPrevGetList(IsCost, supplierId, fldFKStyle) || fetchCompactingDCPreviousGetList(fldFKStyle, 0, fldFkProgramId, salesId),
            fetchCompactingDCDetailsById(parseInt(formData.fldFKDCNo)),
            reprocessID === true ? fetchCompactingDCReprocessPrevGetList(IsCost, supplierId, fldFKStyle) :
                fetchCompactingDCPreviousGetList(fldFKStyle, 0, fldFkProgramId, salesId,

                )
        ]
    };


    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleCompactingDCDetails = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDCDetailsGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_COMPACTING_DC_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_COMPACTING_DC_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_COMPACTING_DC_DETAILS_FAILURE,
        singlApiArray: [
            // fetchYarnPODetailsGroupListDropdown(),
            // fetchKnittingDCPreviousGetList(),
            // fetchCommonPropertyById(57), // agent name
            // fetchCommonPropertyById(58), // mill name
            // fetchCommonPropertyById(22), // UOM
            // fetchHSNMaster(),
            // fetchColorDetailsWithoutId(),
            // fetchYarnPOOfPoNo()
        ]
    };
    return axiosCall(config);
};

export let fetchCompactingDCPreviousGetList = (style, value, fkDetailID, salesId,) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDCPreviousGetList}?FldFKStyleId=${style}&FldFKStyleDetailId=${fkDetailID}&FldFkProgramCode=COD&IsUpdated=${value}&FldFKSaleOrder=${salesId}`,
        responseTypeRequest: FETCH_COMPACTING_DC_PREVIOUS_LIST_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_PREVIOUS_LIST_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_PREVIOUS_LIST_FAILURE
    };
    return axiosCall(config);
};

export let fetchStylePrepDiaByProgram = (style, fabGrp, yarnCnt, fabric, dia, programId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.GetStylePrepDiaByProgram}?FldFKStyle=${style}&FabGrp=${fabGrp}&YarnCnt=${yarnCnt}&Fab=${fabric}&Dia=${dia}&FldFKProgram=${programId}`,
        responseTypeRequest: FETCH_COMPACTING_DC_DETAILS_DIA_FROM_STYLE_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_DETAILS_DIA_FROM_STYLE_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_DETAILS_DIA_FROM_STYLE_FAILURE
    };
    return axiosCall(config);
};


export let fetchCompactingDCReprocessPrevGetList = (IsCost, supplierId, fldFKstyle) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDCReProcessPreviousGetList}?FldIsWithCost=${IsCost}&FldFKSupplierId=${supplierId}&FldFKStyle=${fldFKstyle}`,
        responseTypeRequest: FETCH_COMPACTING_DC_DETAIL_REPROCESS_PREV_LIST_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_DETAIL_REPROCESS_PREV_LIST_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_DETAIL_REPROCESS_PREV_LIST_FAILURE
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updateCompactingDCDetails = (id, formData, parentId) => {
    let today = new Date();
    let data = JSON.stringify({
        ...formData,
        fldFKStatus: 1317,
        FldFKPreviousDCPO: parseInt(formData.FldFKPreviousDCPO),
        FldPreviousDCPO: formData.FldPreviousDCPO,
        FldFKProgram: parseInt(formData.FldFKProgram),
        FldProgram: formData.FldProgram,
        fldDCNo: formData?.fldDCNo,
        fldFKDCNo: parseInt(formData.fldFKDCNo),
        fldFKProgram: 0,
        fldProgram: 'string',

        fldFKFabricOrDyeingDc: parseInt(formData.fldFKFabricOrDyeingDc),
        // fldFKColour: parseInt(formData.fldFKColour),
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldStyleNumber: formData?.fldStyleNumber,
        fldFKYarnCounts: parseInt(formData.fldFKYarnCounts),
        fldYarnCounts: formData?.fldYarnCounts,
        fldFKColour: parseInt(formData.fldFKColour),
        fldFKColourShade: parseInt(formData.fldFKColourShade),
        fldColourShade: formData?.fldColourShade,
        fldFabricOrDyeingDC: formData?.fldFabricOrDyeingDC,
        fldColour: formData?.fldColour,
        fldFabricGroup: formData?.fldFabricGroup,
        fldFabric: formData?.fldFabric,
        TblFabricname: formData?.fldFabric,
        fldDia: formData?.fldDia,
        fldFKFabricMaster: parseInt(formData.fldFKFabricMaster),
        fldRate: parseInt(formData.fldRate),
        fldQuantity: formData.fldQuantity ? Number(formData.fldQuantity) : 0,
        fldGrossValue: formData.fldGrossValue ? Number(formData.fldGrossValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldTaxableValue: formData.fldTaxableValue ? Number(formData.fldTaxableValue) : 0,
        fldIGSTPercentage: formData.fldIGSTPercentage ? Number(formData.fldIGSTPercentage) : 0,
        fldIGSTValue: formData.fldIGSTValue ? Number(formData.fldIGSTValue) : 0,
        fldSGSTPercentage: formData.fldSGSTPercentage ? Number(formData.fldSGSTPercentage) : 0,
        fldSGSTValue: formData.fldSGSTValue ? Number(formData.fldSGSTValue) : 0,
        fldCGSTPercentage: formData.fldCGSTPercentage ? Number(formData.fldCGSTPercentage) : 0,
        fldCGSTValue: formData.fldCGSTValue ? Number(formData.fldCGSTValue) : 0,
        fldGSTValue: formData.fldGSTValue ? Number(formData.fldGSTValue) : 0,
        fldTotalValue: formData.fldTotalValue ? Number(formData.fldTotalValue) : 0,
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData?.fldEnteredSysId,
        fldCreatedBy: 11,
        fldCreatedDt: today.toISOString(),
        fldFKHSNCode: parseInt(formData.fldFKHSNCode),
        fldFKUOM: parseInt(formData.fldFKUOM),
        fldFKFabricGroup: parseInt(formData.fldFKFabricGroup),
        fldFKFabric: parseInt(formData.fldFKFabric),
        fldFKDia: parseInt(formData.fldFKDia),
        fldFKGSM: parseInt(formData.fldFKGSM),
        fldFKNoofRolls: parseInt(formData.fldFKNoofRolls),
        fldRequiredDia: formData?.fldRequiredDia ? formData?.fldRequiredDia : '0',
        fldRequiredGSM: formData?.fldRequiredGSM || '',
        fldFKWeightinKG: formData.fldFKWeightinKG ? Number(formData.fldFKWeightinKG) : 0,
        fldFKRatePerKG: Number(formData.fldRate),
        fldInwardQuantity: formData?.fldInwardQuantity ? Number(formData?.fldInwardQuantity) : 0,
        fldCancelQuantity: formData?.fldCancelQuantity ? Number(formData?.fldCancelQuantity) : 0,
        fldBalanceQuantity: formData?.fldBalanceQuantity ? Number(formData?.fldBalanceQuantity) : 0,
        fldModifiedBy: 1,
        fldModifiedDt: today.toISOString()
        // fldDeletedBy: 0,
        // fldDeletedDt: today.toISOString(),
    });

    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.compactingDCDetailsPATCH}/${id}`,
        responseTypeRequest: UPDATE_COMPACTING_DC_DETAILS_REQUEST,
        responseTypeSuccess: UPDATE_COMPACTING_DC_DETAILS_SUCCESS,
        responseTypeFailure: UPDATE_COMPACTING_DC_DETAILS_FAILURE,
        resetFormData: COMPACTING_DC_DETAILS_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchCompactingDCDetailsById(parentId)
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteCompactingDCDetails = (id, parentId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.compactingDCDetailsDELETE}/${id}`,
        responseTypeRequest: DELETE_COMPACTING_DC_DETAILS_REQUEST,
        responseTypeSuccess: DELETE_COMPACTING_DC_DETAILS_SUCCESS,
        responseTypeFailure: DELETE_COMPACTING_DC_DETAILS_FAILURE,
        modalClose: true,
        getAllData: fetchCompactingDCDetailsById(parentId)
    };
    return axiosCall(config);
};

export let fetchCompactingDCNoInDyeing = (styleNo, ProgramId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDcDetailsDCNoGET}?ActionCode=COD&StyleNO=${styleNo}&FldFKProgram=${ProgramId}`,
        responseTypeRequest: FETCH_COMPACTING_DC_DETAILS_DC_NO_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_DETAILS_DC_NO_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_DETAILS_DC_NO_FAILURE
    };
    return axiosCall(config);
};

export let fetchGRNNoByCompactingDC = (DcNo, styleNo, value, ProgramId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.GRNNoByCompactingGET}?FldPONO=${DcNo}&StyleNo=${styleNo}&IsUpdated=${value}&FldFKProgram=${ProgramId}`,
        responseTypeRequest: FETCH_GRN_NO_BY_COMPACTING_PO_REQUEST,
        responseTypeSuccess: FETCH_GRN_NO_BY_COMPACTING_PO_SUCCESS,
        responseTypeFailure: FETCH_GRN_NO_BY_COMPACTING_PO_FAILURE
    };
    return axiosCall(config);
};

export let getStyleProgramId = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDCMasterGETID}/${id}`,
        responseTypeRequest: COMPACTING_DC_PROGRAM_ID_REQUEST,
        responseTypeSuccess: COMPACTING_DC_PROGRAM_ID_SUCCESS,
        responseTypeFailure: COMPACTING_DC_PROGRAM_ID_FAILURE
    };
    return axiosCall(config);
};


export let fetchCompactingDCGetFabricStockList = (style, salesID, fldFkProgramId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.dyeingDcDetailsGetListFabStockGET}?FldFKStyle=${style}&FldFKSalesOrder=${salesID}&FldProgramCode=${fldFkProgramId}`,
        responseTypeRequest: FETCH_COMPACTING_DC_FABRIC_STOCK_LIST_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DC_FABRIC_STOCK_LIST_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DC_FABRIC_STOCK_LIST_FAILURE
    };
    return axiosCall(config);
};